import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {SupportComponent} from "../support/support.component";
import {DownloadError} from "./http-download.service";

export interface DownloadErrorDialogModel {
  error: DownloadError;
}

@Component({
  templateUrl: "./http-download-failure-dialog.template.pug",
})
export class HttpDownloadFailureDialogComponent
  extends DialogComponent<DownloadErrorDialogModel, {}>
  implements DownloadErrorDialogModel {
  error: Error;

  static show(dialogService: DialogService, model: DownloadErrorDialogModel): Promise<any> {
    return dialogService.showDialog(HttpDownloadFailureDialogComponent, model, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  support() {
    this.close();
    SupportComponent.showSupportModal(this.dialogService);
  }

  constructor(public dialogService: DialogService) {
    super(dialogService);
  }
}
